import { Component, PipeTransform, Pipe, ElementRef } from "@angular/core";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { MatDialog } from "@angular/material/dialog";
import { WeatherDialogComponent } from "./weather-dialog.component";
import { WeatherWidget, Widget } from "../widgets";
import { ApiService } from "src/app/api.service";
import { GridStackElement } from "gridstack";
import { UiService } from "src/app/ui/ui.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-weather-widget",
  templateUrl: "./weather-widget.component.html",
  styleUrls: ["./weather-widget.component.scss"],
})
export class WeatherWidgetComponent extends GenericWidgetComponent {
  multiplier = 2;
  widget!: Widget;
  weather!: {
    city: String;
    feels_like: number;
    temp: number;
    temp_max: number;
    temp_min: number;
    description: string;
    icon: string;
    type?: string;
  };
  constructor(
    private dialog: MatDialog,
    private APIService: ApiService,
    private _element: ElementRef,
    private uiService: UiService,
  ) {
    super();
  }

  get is1x1() {
    return (
      this.widget.width === this.multiplier &&
      this.widget.height === this.multiplier
    );
  }

  get is1x2() {
    return (
      this.widget.width === this.multiplier &&
      this.widget.height === this.multiplier * 2
    );
  }

  get is2x1() {
    return (
      this.widget.width === this.multiplier * 2 &&
      this.widget.height === this.multiplier
    );
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    if ((this.widget as WeatherWidget).weatherOptions) {
      this.elementLoader
        .waitForEvent(
          this.APIService.currentWeatherData(
            (this.widget as WeatherWidget).weatherOptions?.zipCode,
            (this.widget as WeatherWidget).weatherOptions?.type,
          ),
        )
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe((result) => {
          this.weather = this.toWeatherObj(result);
        });
    }
  }

  toWeatherObj(result: any) {
    return {
      city: result.name,
      feels_like: result.main.feels_like,
      temp: result.main.temp,
      temp_max: result.main.temp_max,
      temp_min: result.main.temp_min,
      description: result.weather[0].description,
      icon: result.weather[0].icon,
      type: (this.widget as WeatherWidget).weatherOptions?.type,
    };
  }

  resize(width: number, height: number) {
    this.widget.resizeWidget(width * this.multiplier, height * this.multiplier);
    this.grid.update(
      this._element as unknown as GridStackElement,
      this.widget._gridStackWidgetOptions,
    );

    this.onResizeWidget.emit();
  }

  openWeatherOptions() {
    this.dialog
      .open(WeatherDialogComponent, {
        data: { options: (this.widget as WeatherWidget).weatherOptions },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          (this.widget as WeatherWidget).updateWeatherOptions(result);
          this.onWidgetOptionsUpdate.emit();
          this.elementLoader
            .waitForEvent(
              this.APIService.currentWeatherData(
                (this.widget as WeatherWidget)?.weatherOptions?.zipCode,
                (this.widget as WeatherWidget)?.weatherOptions?.type,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe((result) => {
              this.weather = this.toWeatherObj(result);
            });
        }
      });
  }
}

@Pipe({ name: "temperature" })
export class TemperaturePipe implements PipeTransform {
  transform(value: number, type?: string): string {
    const postFix = type === "F" ? "°F" : "°C";
    return `${value} ${postFix}`;
  }
}
